BaseModel = require './base_model.coffee'

class global.ContactGroup extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    import_action: {}
    contacts_count: {}
    user_id: {}
    opportunities_percentage: {}
    job_status: {}
  }

  @ASSOCIATIONS = {
    contacts: -> Contact
    user: -> User
  }

  @SERIALIZABLE_ATTRIBUTES = [
    'id', 'name', 'contact_ids_to_be_removed'
  ]

  @SERIALIZABLE_ASSOCIATIONS = [
    'contacts'
  ]

  isProcessing: ->
    @job_status != null && (@job_status.status == 'processing' || @job_status.status == 'unitialized')

  isWithError: ->
    @job_status != null && @job_status.status == 'error'

  hasStatusMessage: ->
    @isProcessing() || @isWithError()

  serialize: ->
    serialized = super

    contacts_attributes = []

    for contact in @contacts
      if contact.isPersisted()
        contacts_attributes.push { id: contact.id } if contact.contact_group_id != @id
      else
        contacts_attributes.push contact.serialize()

    serialized.contacts_attributes = contacts_attributes
    serialized



// WEBPACK FOOTER //
// ./src/models/contact_group.coffee